import React, {useEffect} from "react";
import {useSelector} from "react-redux";
import { gaDataLayer } from "../../utils";
import {certificationPage } from "../../utils/registrationUtils";
import { domainValue } from "../../constants/dashboard";

function DataLayerEvents (props) {
  const { user: _user } = useSelector((state) => state.userData);
    
    const subDomainName = window.location.host?.split(".")[0];
    const urlCheck = window.location.href;
    let certificationFormCheck = window.location.search?.includes("ftype=certificationform") ||
    window.location.search?.includes("ftype=certification") || certificationPage(urlCheck);
    let launguageCheck =  (window.location.href?.includes("/hi/") || subDomainName == "hindinews") ? "HI" : "EN";
    let domainData = domainValue?.filter((obj) => subDomainName === obj.domain);
    let domainId = certificationFormCheck ? "23" : domainData?.[0]?.value ? domainData?.[0]?.value : "18";

    useEffect(() => {
   const timeout = setTimeout(() => {
          if (_user) {
            let data = [
              props.contentType,
              props.pageTypes,
              domainId,
              props.verticalName,
              "",
              "",
              "",
              "",
              "",
              "Yes",
              _user?.data?.id,
              "No",
              launguageCheck,
              "",
              "",
            ];
            gaDataLayer(...data);
          }else {
            let data = [
                props.contentType,
                props.pageTypes,
                domainId,
                props.verticalName,
                "",
                "",
                "",
                "",
                "",
                "No",
                "",
                "No",
                launguageCheck,
                "",
                "",
              ];
              gaDataLayer(...data);
          }
        }, 1000);
        return () => clearTimeout(timeout);
      }, [_user]);

    return<></>
}
export default DataLayerEvents;